import { FC } from 'react'
import './inactivity-nudge.css'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'


export interface InactivityNudgeProps {
    daysSinceActivity: number
    groupOrganizer: User
    isOrganizer: boolean
    isMerchantGroup: boolean
    hasTransactions: boolean
    onCloseGroup: () => void
    onCloseNudge: () => void
    onParticipantLeave?: () => void
}

const InactivityNudge: FC<InactivityNudgeProps> = (props) => {
    const { daysSinceActivity, groupOrganizer, onCloseGroup, onCloseNudge, isOrganizer, isMerchantGroup, hasTransactions, onParticipantLeave } = props
    const hideCloseButton = isMerchantGroup && isOrganizer && !hasTransactions
    const organizerName = `${groupOrganizer.givenName || ''} ${groupOrganizer.familyName || ''}`.trim()

    return (
        <div className='inactivity-nudge'>
            <div className="flex flex-row gap-4 items-start">
                <div className="bubble-xsml checkmark flex items-center justify-center" style={{ background: 'var(--splitcard-yellow-200)' }}>
                    <Icons.Clock width="1.5rem" height="1.5rem" tint="var(--splitcard-yellow-600)" />
                </div>
                <div className="flex flex-col gap-4 flex-1">
                    {isOrganizer
                        ? hasTransactions
                            ? "Ready to wrap up?"
                            : 'Group funds are ready!'
                        : "Need to leave this group?"
                    }
                    <p className='text-body'>{
                        isOrganizer
                            ? hasTransactions
                                ? `Your group hasn't been used in ${daysSinceActivity} days. Close the group below or continue to spend and close when you are done.`
                                : 'Your group funds are available. When you are ready, so is your card.'
                            : hasTransactions
                                ? `This group hasn’t been used in ${daysSinceActivity} days, but funds are still on the card. ${organizerName} can keep using it, close the group or you can cash out if you are done spending. You’ll be notified if the group is closed or more activity happens.`
                                : `Your group has funds ready. ${organizerName} can start spending or you can cash out if you aren\'t going to spend your contribution. You\'ll be notified if the group is closed or activity happens.`
                    }</p>
                    <div className="flex flex-row gap-4">
                        {!hideCloseButton && <Button theme="primary" size="small" onClick={isOrganizer ? onCloseGroup : onParticipantLeave} style={{ background: 'var(--splitcard-yellow-600)', borderColor: 'var(--splitcard-yellow-600)' }}>{isOrganizer ? `${hasTransactions ? 'Close' : 'Cancel'} Group Now` : 'Leave Group Now'}</Button>}
                        <Button theme="secondary" size="small" onClick={onCloseNudge} style={{ borderColor: 'var(--splitcard-yellow-600)', color: 'var(--splitcard-yellow-600)' }}>{isOrganizer ? 'Not yet' : 'Stay'}</Button>
                    </div>
                </div>
                <Icons.Close tint="var(--splitcard-yellow-600)" width="1.25rem" height="1.25rem" onClick={onCloseNudge} style={{ alignSelf: 'flex-start', cursor: 'pointer' }} />
            </div>
        </div>
    )
}

export default InactivityNudge
